import { FormReadiness, SubmitButton } from '../forms/ValidatedForm';

export default function AdminPublishBar({ dirty, saving, label, onDiscard }) {
  return (
    <div className="admin-publish-bar">
      <FormReadiness />
      <div className={`admin-save-state${dirty ? " is-dirty" : ""}`} aria-live="polite">
        <strong>{dirty ? "Unsaved changes" : "All changes saved"}</strong>
        <span>{dirty ? "Review and publish when ready." : "This section matches the published site."}</span>
      </div>
      <div className="admin-publish-actions">
        <button type="button" onClick={onDiscard} disabled={!dirty || saving}>Discard changes</button>
        <SubmitButton className="admin-primary" disabled={!dirty || saving}>
          {saving ? "Publishing…" : label}
        </SubmitButton>
      </div>
    </div>
  );
}
